import { endpoints } from '@/config/endpoints.config'

export default function useApiEndpoints() {
  const { t } = useI18n()
  const localePath = useLocalePath()

  const getEndpoint = (id: ApiEndpointId) => {
    const endpoint = endpoints.find(endpoint => endpoint.id === id)

    if (endpoint) {
      return {
        ...endpoint,
        text: t(endpoint.text),
        to: localePath({
          name: 'api-slug',
          params: { slug: endpoint.loc.replace('/api/', '') },
        }),
      }
    }
  }

  const getEndpoints = (category?: ApiEndpointCategory) => {
    return endpoints
      .filter(endpoint => category ? endpoint.id.startsWith(`${category}-`) : true)
      .map(endpoint => ({
        ...endpoint,
        text: t(endpoint.text),
        to: localePath({
          name: 'api-slug',
          params: { slug: endpoint.loc.replace('/api/', '') },
        }),
      }))
  }

  return {
    getEndpoint,
    getEndpoints,
  }
}
